import { animate } from 'motion';
import { EASING_OPTION } from '@bg-shared';
import { SideScrollDirection } from './enums/SideScrollDirection';

const SIDE_SCROLL_LIMIT = 150;
const SIDE_SCROLL_DURATION = 0.2; // s

export const sideScroll = (scrollbar: HTMLElement, direction: SideScrollDirection): void => {
    const startScroll = scrollbar.scrollLeft;
    const scrollDirection = direction === SideScrollDirection.LEFT ? -1 : 1;

    animate(
        (progress) => {
            scrollbar.scrollLeft = startScroll + SIDE_SCROLL_LIMIT * progress * scrollDirection;
        },
        { duration: SIDE_SCROLL_DURATION, easing: EASING_OPTION.EASE_OUT_CUBIC },
    );
};
